export const GET_BRANDS = 'containers/BrandsProviderV2/GET_BRANDS';
export const UPDATE_BRANDS = 'containers/BrandsProviderV2/UPDATE_BRANDS';
